module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "Wave2.22db6b94.svg";